import { useRef } from 'react';
import SimpleReactValidator from 'simple-react-validator';

const Validator = () => {
    const allChecksPassed = (checks) => {
        return Object.values(checks).every(Boolean);
    }

    return useRef(new SimpleReactValidator({
        className: 'text-danger',
        validators: {
            oldPasswordRequired: {
                message: 'Please enter the old password.',
                rule: (val) => val !== undefined && val !== '',
                required: true
            },
            newPasswordRequired: {
                message: 'Please enter a new password.',
                rule: (val) => val !== undefined && val !== '',
                required: true
            },
            passwordStrength: {
                message: 'Your password does not meet all requirements.',
                rule: (val) => {
                    if (!val) {
                        return false; // If val is undefined or empty, return false
                    }

                    const checks = {
                        minLength: val.length > 7,
                        upperCase: /[A-Z]/.test(val),
                        number: /\d/.test(val),
                        specialChar: /[`!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/.test(val)
                    };

                    return allChecksPassed(checks);
                },
                required: true
            },
            confirmPasswordRequired: {
                message: 'Please re-enter the new password.',
                rule: (val) => val !== undefined && val !== '',
                required: true
            },
            passwordsMatch: {
                message: 'New password and Confirm password should match.',
                rule: (val) => {
                    return val.newPassword && val.confirmPassword && val.newPassword === val.confirmPassword;
                }
            },
            passwordsDifferent: {
                message: 'New password cannot be the same as your current password.',
                rule: (val) => {
                    return val.oldPassword && val.newPassword && val.oldPassword !== val.newPassword;
                }
            },
            usernameRequired: {
                message: 'Please enter an email or username.',
                rule: (val) => val !== undefined && val !== '',
                required: true,
            },
            usernameNoSpace: {
                message: 'Email or username should not contain white spaces',
                rule: (val) => {
                    const pattern = /^\S*$/;
                    return pattern.test(val);
                }
            },
            passwordRequired: {
                message: 'Please enter a password.',
                rule: (val) => val !== undefined && val !== '',
                required: true,
            },
            passwordLength: {
                message: 'Password length must be between 8 and 20 characters',
                rule: (val) => val !== undefined && val !== '' && val.length <= 20 && val.length >= 8,
            },
            nameRequired: {
                message: 'Please enter a name.',
                rule: (val) => val !== undefined && val !== '',
                required: true
            },
            emailRequired: {
                message: 'Please enter an email address.',
                rule: (val) => val !== undefined && val !== '',
                required: true
            }
        },
        messages: {
            email: 'Please enter a valid email address',
        },
    })).current;
    
}

export default Validator;
